import React from 'react';
import styled, { css } from 'styled-components';

import { useTranslation } from '@components/I18nProvider';
import { isNotNullish } from '@tager/web-core';

import { media } from '@/utils/mixin';
import { Investment } from '@/typings/model';

type Props = {
  investment: Investment;
};

function WidgetInvestmentIdeas({ investment }: Props) {
  const { taxes } = investment;
  const { t, language } = useTranslation();
  return (
    <Investing>
      <Title>
        {t('investIn')} {investment.name}
      </Title>
      <FormInvest>
        <InputBlock>
          <InputWrapper>
            <BeforeText>$</BeforeText>
            <Input defaultValue={investment.minAmount.toLocaleString('ru')} />
            <AfterText>
              {language === 'ru' ? 'Мин' : 'Min'}.
              <br /> {investment.minAmount.toLocaleString('ru')} $
            </AfterText>
          </InputWrapper>
        </InputBlock>
        <Button href={investment.url} target="_blank">
          {t('invest')}
        </Button>
      </FormInvest>
      {investment.requestsDeadline ? (
        <InvestParams>
          <ParamsTitle>{t('applicationsBefore')}</ParamsTitle>
          <Params> {investment.requestsDeadline}</Params>
        </InvestParams>
      ) : null}
      {investment.finishDate ? (
        <InvestParams>
          <ParamsTitle>{t('finish')}</ParamsTitle>
          <Params> {investment.finishDate}</Params>
        </InvestParams>
      ) : null}
      {taxes ? (
        <InvestParams>
          <ParamsTitle>{t('commissions')}</ParamsTitle>
          {isNotNullish(taxes.enter) ? (
            <Params>
              {t('enter')} {taxes.enter}%
            </Params>
          ) : null}
          {isNotNullish(taxes.exit) ? (
            <Params>
              {t('leave')} {taxes.exit}%
            </Params>
          ) : null}
          {isNotNullish(taxes.profit) ? (
            <Params>
              {' '}
              {t('profit')} {taxes.profit}%
            </Params>
          ) : null}
          {isNotNullish(taxes.management) ? (
            <Params>
              {t('management')} {taxes.management}%
            </Params>
          ) : null}
        </InvestParams>
      ) : null}
    </Investing>
  );
}

const Investing = styled.div`
  margin: 25px 0;
  background: var(--invest-bg-color);
  padding: 25px 20px;
  ${media.mobile(css`
    margin-left: -15px;
    margin-right: -15px;
  `)}
`;
const Title = styled.h3`
  font-size: 20px;
  line-height: 24px;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 13px;
  display: block;
`;
const FormInvest = styled.div`
  display: flex;
  margin-bottom: 20px;
  ${media.mobile(css`
    display: block;
  `)}
`;
const BeforeText = styled.span`
  font-size: 24px;
  line-height: 26px;
  color: #999;
`;
const InputWrapper = styled.div`
  background: var(--form-input-background);
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 0 20px;
  height: 60px;
  line-height: 60px;
  display: flex;
  align-items: center;
  ${media.mobile(css`
    margin-bottom: 10px;
  `)}
`;
const AfterText = styled.span`
  color: #999;
  font-size: 15px;
  line-height: 15px;
  white-space: nowrap;
`;
const Input = styled.input`
  margin: 0 10px;
  font-size: 24px;
  background: var(--form-input-background);
  color: var(--form-input-color);
  line-height: 58px;
  border: 0;
  display: block;
  width: 100%;
`;
const InputBlock = styled.div`
  flex: 2 1 auto;
`;
const Button = styled.a`
  margin: auto 0 auto 15px;
  height: 50px;
  background: var(--blue-color);
  color: #fff;
  line-height: 50px;
  text-align: center;
  display: inline-block;
  font-size: 18px;
  padding: 0 40px;
  border-radius: 3px;
  cursor: pointer;
  ${media.mobile(css`
    width: 100%;
    margin-left: 0;
  `)}
  &:hover {
    background: #0e5bb6;
  }
`;

const InvestParams = styled.div`
  display: inline-block;
  span {
    font-size: 13px;
    white-space: nowrap;
    line-height: 100%;
  }
`;
const ParamsTitle = styled.span`
  display: block;
  color: #999;
  //margin-bottom: 6px;
`;
const Params = styled.span`
  position: relative;
  margin-right: 20px;
  &:not(:last-child) {
    &:after {
      content: '';
      width: 2px;
      height: 2px;
      border-radius: 50%;
      background: #000000;
      display: block;
      position: absolute;
      right: -12px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
`;
export default WidgetInvestmentIdeas;
